import React from "react";
 import "./aboutPage.css";
 
 const AboutPage = () => {
   const sections = [
     {
       title: "ABOUT JUL",
       text: `JUL, markalar için yüksek etkili reklam filmleri, profesyonel fotoğraf prodüksiyonları ve yapay zeka destekli dijital içerikler üreten yaratıcı bir yapım şirketidir. Bizim için JUL, sadece bir isim değil, 1 birim enerji ile dünyayı değiştirme gücüdür.

       Büyük kampanyaların görsel dünyasını inşa ediyor, markaların kimliğini en güçlü ve akılda kalıcı şekilde yansıtan projeler oluşturuyoruz. Reklam filmlerinden moda ve ürün çekimlerine, marka hikâyelerinden kurumsal içeriklere kadar geniş bir hizmet yelpazesi sunuyoruz. Yapay zeka destekli fine-tuning süreçleriyle dijital karakterler üretiyor, her detayda mükemmel sonuçlar elde ediyoruz. En yeni teknolojileri, estetik bir bakış açısıyla harmanlayarak, müşterilerimize hem yaratıcı hem de etkili görsel çözümler sunuyoruz.

       Son dönemde bağımsız sinema alanında da projeler geliştiren JUL, hikâye anlatımındaki derin bilgisini sinema dünyasına taşımayı hedefliyor. Ancak asıl uzmanlık alanımız, büyük markaların kampanyalarına özgün ve yüksek kaliteli prodüksiyonlar yaratmaktır.

       Ayrıca, JUL Akademi ile sektörün geleceğine yatırım yapıyoruz. Masterclass programlarımız ve sektördeki yetkin isimlerle gerçekleştirdiğimiz etkinliklerle, genç profesyonelleri bir araya getiriyor ve yaratıcı endüstrilerde sürdürülebilirlik ile yenilikçiliği destekliyoruz.

       Çünkü biz bir gülücükle dünyanın değişeceğine inanıyoruz. 😊

       JUL = 1 birim enerji, sonsuz yaratıcılık.`
     },
    
   ];
 
   return (
     <div className="about-page">
       {sections.map((section, index) => (
         <div className="about-section" key={index}>
           <h2 className="about-section-title">{section.title}</h2>
           <p className="about-section-text">{section.text}</p>
         </div>
       ))}
     </div>
   );
 };
 
 export default AboutPage;